import React, { useState, useRef, memo, useEffect } from "react"
import Styles from "../styles/Footer.module.scss";
import { Link, navigate } from "gatsby"
import MediaQuery from "react-responsive";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faTags, faUsers, faUser, faSignOutAlt,
    faTimes, faInfoCircle, faBuilding, faCog,
} from '@fortawesome/free-solid-svg-icons'
import { faFileAlt, faQuestionCircle, faEnvelope } from '@fortawesome/free-regular-svg-icons'
import DrawerMenu, { MenuItemType } from "../components/DrawerMenu";
import { connect } from "react-redux";
import { setAllowFetchNotificationNumber, setBadgeNumber, resetStore, AppState } from "../state/app";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import client from "../apis/client";
import { HomeIcon } from "../icons/HomeIcon";
import { SearchIcon } from "../icons/Search";
import { BellIcon } from "../icons/BellIcon";
import { UserOutlineIcon } from "../icons/UserOutlineIcon";
const fetchNotificationNumberIntervalAtLeast = 60000


const FooterList = [
    { to: "/home", filename: "icon_home.png", label: "ホーム", icon:<HomeIcon className={Styles.SP_footer_icon}/> },
    { to: "/post_search", filename: "icon_search.png", label: "検索", icon: <SearchIcon className={ Styles.SP_footer_icon }/>},
    { to: "/notification", filename: "icon_notification.png", label: "お知らせ", icon: <BellIcon className={ Styles.SP_footer_icon }/> },
    { to: "/mypage", filename: "icon_mypage.png", label: "マイページ", icon: <UserOutlineIcon className={ Styles.SP_footer_icon }/> }
]

type Props = {
    resetStore: () => void,
    allowFetchNotificationNumber: boolean,
    setAllowFetchNotificationNumber: ( bool: boolean ) => void,
    badgeNumber: number,
    setBadgeNumber: ( number: number ) => void
    isLoggedIn:boolean
}

const Footer = memo( ( { resetStore, allowFetchNotificationNumber, setAllowFetchNotificationNumber, badgeNumber, setBadgeNumber, isLoggedIn}: Props ) => {

    const [ selectedTabIndex, setSelectedTabIndex ] = useState( typeof window !== 'undefined' ? Number( localStorage.getItem( "selectedTabIndex" ) ) : 0 )
    const [ drawerOpen, setDrawerOpen ] = useState( false )
    const [ aboutClubCloudDrawerOpen, setAboutClubCloudDrawerOpen ] = useState( false )
    const allowFetchNotificationNumberRef = useRef( allowFetchNotificationNumber )

    const logout = () => {
        if ( window.confirm( '本当にログアウトしますか？' ) ) {
            client.post( "logout", {}, { withCredentials: true } )
                .then( res => {
                    localStorage.clear()
                    sessionStorage.clear()
                    resetStore()
                    navigate( "/" )
                } )
                .catch( e => {
                    console.log( e )
                    alert( "ログアウトに失敗しました" )
                } )
        }
        return
    }

    const menuList = [
        { name: "", icon: faTimes, func: () => setDrawerOpen( false ) },
        { name: "チーム情報", icon: faUsers, func: () => navigate( "/team_info" ) },
        { name: "登録情報変更", icon: faUser, func: () => navigate( "/user_update" ) },
        { name: "ログアウト", icon: faSignOutAlt, func: () => logout() },
    ]
    const aboutClubCloudMenuList: MenuItemType[] = [
        { name: "", icon: faTimes, func: () => setAboutClubCloudDrawerOpen( false ) },
        { name: "利用規約", icon: faFileAlt as IconProp, func: () => navigate( "/terms" ) },
        { name: "プライバシーポリシー", icon: faUser, func: () => navigate( "/privacy_policy" ) },
        { name: "クラウドファンディング支援者一覧", icon: faUsers, func: () => navigate( "/cf_supporter_list" ) },
    ]

    const lowerListMenu: MenuItemType[] = [
        { name: "タグ", func: () => navigate( "/tag_management" ), icon: faTags, },
        { name: "チーム", func: () => navigate( "/team_info" ), icon: faUsers, },
        { name: "登録情報", func: () => navigate( "/user_update" ), icon: faUser, },
        { name: "設定", icon: faCog, func: () => navigate( "/settings" ) },
        { name: "", func: () => { }, icon: null, },
        { name: < p style={ { fontSize: "0.9rem" } } className={ Styles.lower_menu_label }>運営からのお知らせ</p >, func: () => navigate( "/news_list" ), icon: faEnvelope as IconProp, },
        { name: <p style={ { fontSize: "0.9rem" } } className={ Styles.lower_menu_label }>ClubCloudについて</p>, func: () => setAboutClubCloudDrawerOpen( true ), icon: faBuilding, },
        { name: "ログアウト", func: () => logout(), icon: faSignOutAlt, },
        { name: "お問い合わせ", func: () => navigate( "/contact" ), icon: faInfoCircle, },
        { name: "ヘルプ", func: () => navigate( "/help" ), icon: faQuestionCircle as IconProp, },
    ]

    useEffect( () => {
        const index = localStorage.getItem( "selectedTabIndex" )
        index && JSON.parse( index ) !== selectedTabIndex && setSelectedTabIndex( Number( index ) )
        document.addEventListener( "visibilitychange", handleChangePageVisibility )
        if ( !window.startApp ) { //初回はundefinedになる 起動時に取得
            fetchNotificationNumberFromServer()
            window.startApp = true
        }
        return () => document.removeEventListener( "visibilitychange", handleChangePageVisibility )
    }, [ isLoggedIn ] )

    useEffect( () => {
        allowFetchNotificationNumberRef.current = allowFetchNotificationNumber
    }, [ allowFetchNotificationNumber ] )

    useEffect( () => {
        localStorage.setItem( "selectedTabIndex", JSON.stringify( selectedTabIndex ) )
    }, [ selectedTabIndex ] )

    const fetchNotificationNumberFromServer = async () => {
        if ( !allowFetchNotificationNumberRef.current ) return
        if ( !isLoggedIn ) return
        setAllowFetchNotificationNumber( false )
        await client.get( `/api/user_notification_number/`, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        } )
            .then( async response => {
                const badge_number = response.data.badge_number;
                setBadgeNumber( badge_number )
            } )
            .catch( error => { } );
        setTimeout( () => setAllowFetchNotificationNumber( true ), fetchNotificationNumberIntervalAtLeast )
    }

    const handleChangePageVisibility = () =>
        document.visibilityState === "visible" && fetchNotificationNumberFromServer()



    if ( !isLoggedIn ) {
        return (
            <footer className={ Styles.footer }>
                <MediaQuery query="(min-width: 900px)">
                    <div className={ Styles.to_top }>
                        <Link to="/">
                            <p>トップページは</p>
                            <p>こちら</p>
                        </Link>
                    </div>
                </MediaQuery>
            </footer>
        )
    }

    return (
        <footer className={Styles.footer}>
            <ul className={ Styles.footer_list }>
                { FooterList.map( ( item, index ) =>
                    <li onClick={ () => setSelectedTabIndex( index ) } className={ selectedTabIndex === index ? Styles.selected_tab : "" } key={ index }>
                        <Link to={ item.to } className={ `${ Styles.tab_link } ${ selectedTabIndex === index ? Styles.selected_tab : "" }` }>
                            {item.icon}
                            <span className={ Styles.menu_label }>{ item.label }</span>
                        </Link>
                        { ( item.label === "お知らせ" && badgeNumber !== 0 ) &&
                            <div className={ Styles.badge_number }>{ badgeNumber }</div> }
                    </li>
                ) }
            </ul>
            <MediaQuery query="(min-width: 900px)">
                <ul className={ Styles.lower_list }>
                    { lowerListMenu.map( ( menu, index ) =>
                        <li tabIndex={1} onClick={ ( e ) => { e.preventDefault(); menu.func() } } key={ String( index ) }>
                            <div>
                                { menu.icon &&
                                    <FontAwesomeIcon className={ Styles.lower_list_menu_icon } icon={ menu.icon } /> }
                                <span className={ Styles.lower_menu_label }>{ menu.name }</span>
                            </div>
                        </li>
                    ) }
                </ul>
                <DrawerMenu drawerOpen={ drawerOpen } setDrawerOpen={ setDrawerOpen } menuList={ menuList } />
                <DrawerMenu drawerOpen={ aboutClubCloudDrawerOpen } setDrawerOpen={ setAboutClubCloudDrawerOpen } menuList={ aboutClubCloudMenuList } />
            </MediaQuery>
        </footer>
    )
} )

const mapStateToProps = ( state: AppState ) => ( {
    badgeNumber: state.app.badgeNumber,
    allowFetchNotificationNumber: state.app.allowFetchNotificationNumber,
    isLoggedIn: state.app.isLoggedIn
} )

const mapDispatchToProps = {
    setAllowFetchNotificationNumber,
    setBadgeNumber,
    resetStore
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)( Footer )
